import { render, staticRenderFns } from "./TabAssets.vue?vue&type=template&id=d8b27644&"
import script from "./TabAssets.vue?vue&type=script&lang=js&"
export * from "./TabAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports